import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={18}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M14.159 1.973a4.095 4.095 0 00-5.795 0l-6.23 6.23a.482.482 0 10.682.681l6.23-6.23a3.132 3.132 0 014.43 0 3.132 3.132 0 010 4.431l-8.615 8.616a1.93 1.93 0 01-2.727 0 1.93 1.93 0 010-2.727L10.41 4.7a.723.723 0 111.023 1.023l-7.934 7.934a.482.482 0 10.681.682l7.934-7.934a1.686 1.686 0 10-2.386-2.386l-8.274 8.275a2.895 2.895 0 000 4.09 2.883 2.883 0 002.045.846c.74 0 1.48-.282 2.045-.846l8.616-8.616a4.102 4.102 0 000-5.794z"
        fill="#000"
        fillOpacity={0.8}
      />
    </Svg>
  );
}

export default SvgComponent;
